import { useEffect, useState, memo } from 'react';
import { Row, FloatingLabel, Col } from 'react-bootstrap';
import Select from 'react-select';

const LocationTypeAndLocation = ({
  onLocationTypeChange,
  locations,
  optionTypes,
  disable,
  moduleName,
  onLocationsSelect,
  data,
  isMulti,
  databaseRoles,
}) => {
  const [selectedType, setSelectedType] = useState('');
  const [selectedLocations, setSelectedLocations] = useState(null);
  const [options, setOptions] = useState(null);

  const handleLocationTypeChange = (event) => {
    setSelectedType(event.target.value);
    onLocationTypeChange(event.target.value, moduleName);
    // Update location options
    const optionLocations = locations.map((item) => ({ value: item?.id, label: item?.name, type: item?.type }));
    setOptions(optionLocations.filter((item) => item.type === event.target.value));
    // Setting selected as null
    setSelectedLocations(null);
  };

  const locationChangeHandler = (selectedOptions) => {
    setSelectedLocations(selectedOptions);
    onLocationsSelect(isMulti ? selectedOptions.map((op) => op.value) : [selectedOptions.value], moduleName);
  };

  useEffect(() => {
    if (locations) {
      if (data) {
        const optionLocations = locations.map((item) => ({ value: item?.id, label: item?.name, type: item?.type }));
        setOptions(optionLocations.filter((item) => item.type === data.locationType));
      } else {
        setOptions(locations.map((item) => ({ value: item?.id, label: item?.name, type: item?.type })));
      }
      setSelectedType(data?.locationType ?? '');
      const editingLocations = locations.filter((item) => data?.locations?.includes(item.id));
      if (editingLocations) {
        setSelectedLocations(editingLocations.map((item) => ({ value: item?.id, label: item?.name, type: item?.type })));
      }
    }
  }, [locations]);

  return (
    <Row>
      <Col xs={4}>
        <FloatingLabel label="Location Type" className="mb-3">
          <select
            disabled={disable || databaseRoles.includes(moduleName)}
            required
            name="locationType"
            value={selectedType}
            onChange={handleLocationTypeChange}
            aria-label="Floating label select example"
            className="form-select"
          >
            <option value="">Select Location Type</option>
            {optionTypes.map((option) => (
              <option key={option} value={option.toLowerCase()}>
                {option}
              </option>
            ))}
          </select>
        </FloatingLabel>
      </Col>
      <Col xs={8}>
        <Select
          isDisabled={disable | (selectedType === '')}
          value={selectedLocations}
          onChange={locationChangeHandler}
          options={options}
          isMulti={isMulti}
          className="basic-multi-select"
          classNamePrefix="select"
          placeholder="Select Locations"
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '55px',
            }),
          }}
        />
      </Col>
    </Row>
  );
};

export default memo(LocationTypeAndLocation);
